/* MetaBalls ambient — WebGL2 vanilla, port da OGL (config cliente). Nessun bundler/modulo/CDN. */
(function () {
  if (window.__olioMB) return;            // singola istanza
  window.__olioMB = true;

  /* --- config hard-coded ai valori cliente --- */
  var CFG = {
    color: '#e4ef65',
    cursorBallColor: '#e4ef65',
    cursorBallSize: 2.8,
    ballCount: 14,
    animationSize: 33,
    clumpFactor: 2,
    speed: 0.2,
    hoverSmoothness: 0.15,
    enableMouseInteraction: false,
    enableTransparency: true,
    /* BORDO delle palline: un anello leggermente piu' scuro del riempimento.
       Prima non esisteva: quello che si vedeva su ALCUNI schermi era un artefatto
       (il colore veniva premoltiplicato per l'alpha ma il contesto e' premultipliedAlpha:false,
       quindi i bordi si scurivano due volte) e con lo scaling di Windows diventava visibile
       su un PC e invisibile su un altro. Ora l'anello e' disegnato apposta: uguale ovunque.
       14 set 2026: assottigliato (era 0.34) — il cliente lo trovava troppo marcato, "da fumetto". */
    /* 15 set 2026: era #c2ce4a, un verde-lime quasi identico al riempimento (#e4ef65) - stessa
       famiglia di colore, solo un filo piu' scuro. Tre correzioni sulla NITIDEZZA GEOMETRICA
       (sfumatura dimezzata due volte, risoluzione del canvas portata a 3x) e il cliente continuava
       a non vedere differenza: il sospetto cambia. Un bordo perfettamente a fuoco ma quasi dello
       stesso colore del riempimento non si legge come "bordo definito" a colpo d'occhio, qualunque
       sia la sua nitidezza geometrica. Sostituito con --filo-1 (#8A7526, gia' nel brand: e' l'ombra
       del filo d'oro), molto piu' scuro e saturo - un anello che si vede, non solo che c'e'. */
    edgeColor: '#8A7526',
    edgeWidth: 0.14,
    /* 15 set 2026 (2): trovata la vera causa dei tre tentativi falliti. Verificato in sandbox a
       viewport 390px (iPhone): .olio-mb da mobile sta a opacity:.18 (assets/olio.css) per non
       "lavare" i titoli. Quell'opacita' e' sull'INTERO canvas, quindi moltiplica anche il bordo:
       un bordo perfetto e ben colorato a piena opacita' (verificato: si vede bene) diventa quasi
       invisibile una volta schiacciato al 18%. Ecco perche' sfumatura e colore, corretti singolarmente
       e verificati, non cambiavano nulla sul telefono reale: l'attenuazione a valle li annullava
       comunque. Fix: l'alpha del bordo (non del riempimento) viene amplificata nello shader stesso,
       cosi' regge meglio la moltiplicazione per l'opacita' del contenitore senza dover alzare
       l'opacita' generale (che rilavarebbe i titoli - il motivo per cui era stata abbassata). */
    edgeAlphaBoost: 2.6,
    /* nitidezza: il canvas seguiva sempre 1 pixel-per-CSS-pixel, quindi su schermi ad alta
       densita' (e con lo scaling di Windows) veniva ingrandito dal browser -> bordi morbidi.
       15 set 2026: il cap era a 2, ma gli iPhone da 12 in poi (e molti Android) sono a 3x -
       verificato: su uno schermo 390 CSS px il canvas disegnava a 780px reali invece dei 1170
       che lo schermo puo' mostrare, e il browser allargava quei 780px per riempire lo spazio,
       sfocandoli. Tutto l'affinamento del bordo nello shader non serviva a niente su quei
       telefoni: il collo di bottiglia non era li', era la risoluzione del canvas stesso. Cap a
       3 (nessun telefono comune supera questo valore; oltre sarebbe fill-rate sprecato davvero). */
    dpr: Math.min(window.devicePixelRatio || 1, 3)
  };

  function boot() {
    /* prefers-reduced-motion -> nessun effetto (disabilitato) */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    if (document.querySelector('.olio-mb')) return;

    var container = document.createElement('div');
    container.className = 'olio-mb';
    container.setAttribute('aria-hidden', 'true');
    container.style.cssText = 'position:fixed;inset:0;z-index:1;pointer-events:none;overflow:hidden';

    var canvas = document.createElement('canvas');
    canvas.style.cssText = 'display:block;width:100%;height:100%';

    /* --- GUARD-RAIL: WebGL2 --- */
    var GL_ATTRS = {
      alpha: true, premultipliedAlpha: false, antialias: false,
      depth: false, stencil: false, powerPreference: 'low-power'
    };
    var gl = null;
    try { gl = canvas.getContext('webgl2', GL_ATTRS); } catch (e) { gl = null; }
    if (!gl) return; // non supportato -> nessun effetto, nessun errore, sito integro

    document.body.appendChild(container);
    container.appendChild(canvas);

    /* --- shader (verbatim dall'originale OGL) --- */
    var VERT =
      '#version 300 es\n' +
      'precision highp float;\n' +
      'layout(location = 0) in vec2 position;\n' +
      'void main() {\n' +
      '  gl_Position = vec4(position, 0.0, 1.0);\n' +
      '}\n';

    var FRAG = [
      '#version 300 es',
      'precision highp float;',
      'uniform vec3 iResolution;',
      'uniform float iTime;',
      'uniform vec3 iMouse;',
      'uniform vec3 iColor;',
      'uniform vec3 iCursorColor;',
      'uniform float iAnimationSize;',
      'uniform int iBallCount;',
      'uniform float iCursorBallSize;',
      'uniform vec3 iMetaBalls[50];',
      'uniform float iClumpFactor;',
      'uniform vec3 iEdgeColor;',
      'uniform float iEdgeWidth;',
      'uniform float iEdgeAlphaBoost;',
      'uniform bool enableTransparency;',
      'out vec4 outColor;',
      '',
      'float getMetaBallValue(vec2 c, float r, vec2 p) {',
      '  vec2 d = p - c;',
      '  float dist2 = dot(d, d);',
      '  return (r * r) / dist2;',
      '}',
      '',
      'void main() {',
      '  vec2 fc = gl_FragCoord.xy;',
      '  float scale = iAnimationSize / iResolution.y;',
      '  vec2 coord = (fc - iResolution.xy * 0.5) * scale;',
      '  vec2 mouseW = (iMouse.xy - iResolution.xy * 0.5) * scale;',
      '  float m1 = 0.0;',
      '  for (int i = 0; i < 50; i++) {',
      '    if (i >= iBallCount) break;',
      '    m1 += getMetaBallValue(iMetaBalls[i].xy, iMetaBalls[i].z, coord);',
      '  }',
      '  float m2 = getMetaBallValue(mouseW, iCursorBallSize, coord);',
      '  float total = m1 + m2;',
      '  float aa = min(1.0, fwidth(total));',
      // sagoma esterna (dove finisce la pallina) e riempimento interno: la differenza fra le due e il bordo
      // 15 set 2026: partiva da (-1,1) ["Sfondo troppo cartunato"], dimezzata a (-0.5,0.5)
      // ["piu' nitide"], ora a (-0.28,0.28) ["ancora piu' nitide"] - la sfumatura e' un settimo
      // di quella originale (~0.56*aa contro ~2*aa). Non scesa fino a un taglio netto (0,0): senza
      // MSAA (antialias:false in GL_ATTRS) un bordo perfettamente duro su una forma che si muove
      // ogni frame tremolerebbe (aliasing) invece di restare fermo - il compromesso e' qui.
      // Non tocca l'outColor finale (fix di stasera) ne' edgeWidth/edgeColor.
      '  float fOuter = smoothstep(-0.28, 0.28, (total - 1.3) / aa);',
      '  float fInner = smoothstep(-0.28, 0.28, (total - (1.3 + iEdgeWidth)) / aa);',
      '  vec3 cFinal = vec3(0.0);',
      '  if (total > 0.0) {',
      '    float alpha1 = m1 / total;',
      '    float alpha2 = m2 / total;',
      '    cFinal = iColor * alpha1 + iCursorColor * alpha2;',
      '  }',
      '  vec3 rgb = mix(iEdgeColor, cFinal, fInner);',
      // 15 set 2026: il commento sopra diceva "il colore non va premoltiplicato" - vero SOLO se
      // il browser rispetta davvero premultipliedAlpha:false alla lettera durante il composite
      // canvas->pagina. La versione confermata funzionante del 7 settembre (senza il bordo/
      // edgeColor introdotto dopo) uscivA GIA' premoltiplicata (cFinal * f) - cioe' il contrario
      // di quello che il commento raccomandava, eppure era quella senza il difetto del bianco che
      // vira sul freddo segnalato dal cliente. Tornati alla stessa forma (colore * alpha finale),
      // qui applicata al colore che include gia' il bordo, cosi' la funzione bordo resta.
      // 15 set 2026 (2): il bordo da solo, con la sua sola opacita' fOuter (identica al riempimento),
      // viene schiacciato quanto il riempimento quando .olio-mb sta a opacity bassa da mobile (.18) -
      // ed e' per questo che i tre fix precedenti (sfumatura x2, risoluzione 3x) restavano invisibili
      // sul telefono reale pur essendo corretti. borderMask isola solo l'anello (0 nel pieno interno,
      // 0 fuori dalla pallina, ~1 nell'anello); li' l'alpha viene amplificata cosi' il bordo regge
      // meglio la moltiplicazione a valle, senza toccare l'opacita' del riempimento.
      '  float borderMask = fOuter * (1.0 - fInner);',
      '  float outA = enableTransparency ? min(1.0, fOuter + borderMask * (iEdgeAlphaBoost - 1.0)) : 1.0;',
      '  outColor = vec4(rgb * outA, outA);',
      '}'
    ].join('\n');

    function compile(type, src) {
      var sh = gl.createShader(type);
      gl.shaderSource(sh, src);
      gl.compileShader(sh);
      if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) { gl.deleteShader(sh); return null; }
      return sh;
    }
    function fail() { if (container.parentNode) container.parentNode.removeChild(container); }

    /* --- helpers verbatim --- */
    function parseHexColor(hex) {
      var c = hex.replace('#', '');
      return [parseInt(c.substring(0, 2), 16) / 255, parseInt(c.substring(2, 4), 16) / 255, parseInt(c.substring(4, 6), 16) / 255];
    }
    function fract(x) { return x - Math.floor(x); }
    function hash31(p) {
      var r = [p * 0.1031, p * 0.103, p * 0.0973].map(fract);
      var r_yzx = [r[1], r[2], r[0]];
      var dotVal = r[0] * (r_yzx[0] + 33.33) + r[1] * (r_yzx[1] + 33.33) + r[2] * (r_yzx[2] + 33.33);
      for (var i = 0; i < 3; i++) r[i] = fract(r[i] + dotVal);
      return r;
    }
    function hash33(v) {
      var p = [v[0] * 0.1031, v[1] * 0.103, v[2] * 0.0973].map(fract);
      var p_yxz = [p[1], p[0], p[2]];
      var dotVal = p[0] * (p_yxz[0] + 33.33) + p[1] * (p_yxz[1] + 33.33) + p[2] * (p_yxz[2] + 33.33);
      for (var i = 0; i < 3; i++) p[i] = fract(p[i] + dotVal);
      var p_xxy = [p[0], p[0], p[1]];
      var p_yxx = [p[1], p[0], p[0]];
      var p_zyx = [p[2], p[1], p[0]];
      var result = [];
      for (var i = 0; i < 3; i++) result[i] = fract((p_xxy[i] + p_yxx[i]) * p_zyx[i]);
      return result;
    }

    var col = parseHexColor(CFG.color);
    var ccol = parseHexColor(CFG.cursorBallColor);

    /* ballParams (verbatim) — CPU-side, calcolati una volta (indipendenti dal contesto GL) */
    var maxBalls = 50;
    var effectiveBallCount = Math.min(CFG.ballCount, maxBalls);
    var ballParams = [];
    for (var i = 0; i < effectiveBallCount; i++) {
      var idx = i + 1;
      var h1 = hash31(idx);
      var st = h1[0] * (2 * Math.PI);
      var dtFactor = 0.1 * Math.PI + h1[1] * (0.4 * Math.PI - 0.1 * Math.PI);
      var baseScale = 5.0 + h1[1] * (10.0 - 5.0);
      var h2 = hash33(h1);
      var toggle = Math.floor(h2[0] * 2.0);
      var radiusVal = 0.5 + h2[2] * (2.0 - 0.5);
      ballParams.push({ st: st, dtFactor: dtFactor, baseScale: baseScale, toggle: toggle, radius: radiusVal });
    }
    var metaBalls = new Float32Array(effectiveBallCount * 3);
    var mouseBallPos = { x: 0, y: 0 };

    /* --- risorse GL: ricreabili on context-restore --- */
    var prog = null, vao = null, vbo = null, U = null, glReady = false;

    function initGL() {
      var vs = compile(gl.VERTEX_SHADER, VERT);
      var fs = compile(gl.FRAGMENT_SHADER, FRAG);
      if (!vs || !fs) return false;
      prog = gl.createProgram();
      gl.attachShader(prog, vs);
      gl.attachShader(prog, fs);
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return false;
      gl.useProgram(prog);

      /* full-screen triangle (stessa geometria di OGL Triangle) su location 0 */
      vao = gl.createVertexArray();
      gl.bindVertexArray(vao);
      vbo = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, vbo);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      gl.enableVertexAttribArray(0);
      gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);

      U = {};
      ['iResolution', 'iTime', 'iMouse', 'iColor', 'iCursorColor', 'iAnimationSize',
       'iBallCount', 'iCursorBallSize', 'iClumpFactor', 'iEdgeColor', 'iEdgeWidth', 'iEdgeAlphaBoost',
       'enableTransparency'].forEach(function (n) {
        U[n] = gl.getUniformLocation(prog, n);
      });
      U.iMetaBalls = gl.getUniformLocation(prog, 'iMetaBalls[0]');

      gl.uniform3f(U.iColor, col[0], col[1], col[2]);
      gl.uniform3f(U.iCursorColor, ccol[0], ccol[1], ccol[2]);
      gl.uniform1f(U.iAnimationSize, CFG.animationSize);
      gl.uniform1i(U.iBallCount, CFG.ballCount);
      gl.uniform1f(U.iCursorBallSize, CFG.cursorBallSize);
      if (U.iClumpFactor) gl.uniform1f(U.iClumpFactor, CFG.clumpFactor);
      gl.uniform1i(U.enableTransparency, CFG.enableTransparency ? 1 : 0);
      var ecol = parseHexColor(CFG.edgeColor);
      gl.uniform3f(U.iEdgeColor, ecol[0], ecol[1], ecol[2]);
      gl.uniform1f(U.iEdgeWidth, CFG.edgeWidth);
      gl.uniform1f(U.iEdgeAlphaBoost, CFG.edgeAlphaBoost);

      /* replica OGL: programma opaco -> BLEND off; la trasparenza arriva dal canvas alpha + composite browser (premultipliedAlpha:false) */
      gl.disable(gl.BLEND);
      gl.disable(gl.DEPTH_TEST);
      gl.clearColor(0, 0, 0, 0);

      glReady = true;
      return true;
    }

    function resize() {
      var w = container.clientWidth || window.innerWidth;
      var h = container.clientHeight || window.innerHeight;
      var pw = Math.max(1, Math.round(w * CFG.dpr));
      var ph = Math.max(1, Math.round(h * CFG.dpr));
      if (canvas.width !== pw) canvas.width = pw;
      if (canvas.height !== ph) canvas.height = ph;
      canvas.style.width = w + 'px';
      canvas.style.height = h + 'px';
      if (!glReady) return;                 // contesto perso: aggiorno solo le dimensioni, niente chiamate GL
      gl.viewport(0, 0, pw, ph);
      gl.uniform3f(U.iResolution, pw, ph, 0);
    }
    window.addEventListener('resize', resize);

    /* --- luce viva: la pallina-cursore segue il mouse (solo desktop/fine-pointer);
       dopo qualche secondo di inattività torna all'orbita automatica. --- */
    /* inseguimento del cursore disattivato su richiesta: le palle fanno solo l'orbita ambient automatica */

    /* 14 set 2026: rimossa l'inclinazione via giroscopio (DeviceOrientationEvent). Chiedeva il
       permesso al PRIMO TOCCO qualsiasi sul sito (listener globale su touchend, non su un gesto
       dedicato): su iOS il primissimo tap ovunque - un link, il menu, un prodotto - faceva comparire
       un popup di sistema "consentire l'accesso a movimento e orientamento?" mai richiesto
       esplicitamente. Segnalato dal cliente come "sembra rotto". Le bolle restano vive solo con
       l'orbita ambient automatica, uguale su tutti i dispositivi. */

    /* --- clock / pausa: SOLO su tab realmente nascosta (visibilitychange/hidden).
       NON su blur della finestra -> i blob continuano se l'utente clicca DevTools o
       un'altra finestra sullo stesso monitor; si fermano solo se la tab non è visibile. --- */
    var startTime = performance.now();
    var pausedTotal = 0, pauseStart = 0, running = true;
    function pause() { if (running) { running = false; pauseStart = performance.now(); } }
    function play() { if (!running) { pausedTotal += performance.now() - pauseStart; running = true; } }
    document.addEventListener('visibilitychange', function () { if (document.hidden) pause(); else play(); });

    var rafId = null;
    function frame(t) {
      rafId = requestAnimationFrame(frame);
      if (!running || !glReady) return;
      var elapsed = (t - startTime - pausedTotal) * 0.001;
      gl.uniform1f(U.iTime, elapsed);

      for (var i = 0; i < effectiveBallCount; i++) {
        var p = ballParams[i];
        var dt = elapsed * CFG.speed * p.dtFactor;
        var th = p.st + dt;
        var x = Math.cos(th);
        var y = Math.sin(th + dt * p.toggle);
        var posX = x * p.baseScale * CFG.clumpFactor;
        var posY = y * p.baseScale * CFG.clumpFactor;
        metaBalls[i * 3] = posX;
        metaBalls[i * 3 + 1] = posY;
        metaBalls[i * 3 + 2] = p.radius;
      }

      /* pallina-cursore: orbita ellittica automatica (lerp = hoverSmoothness) */
      var cx = canvas.width * 0.5, cy = canvas.height * 0.5;
      var rx = canvas.width * 0.15, ry = canvas.height * 0.15;
      var targetX = cx + Math.cos(elapsed * CFG.speed) * rx;
      var targetY = cy + Math.sin(elapsed * CFG.speed) * ry;
      mouseBallPos.x += (targetX - mouseBallPos.x) * CFG.hoverSmoothness;
      mouseBallPos.y += (targetY - mouseBallPos.y) * CFG.hoverSmoothness;
      gl.uniform3f(U.iMouse, mouseBallPos.x, mouseBallPos.y, 0);

      gl.uniform3fv(U.iMetaBalls, metaBalls);

      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
    }

    /* --- context-loss / restore: senza questo, alla perdita del contesto GPU
       (tab in background a lungo, memoria bassa, cambio GPU) l'effetto muore per sempre. --- */
    canvas.addEventListener('webglcontextlost', function (e) {
      e.preventDefault();                       // consente il restore
      glReady = false;                          // stop pulito del rendering
      pause();                                  // congela il clock -> nessun salto al ripristino
      if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
    }, false);
    canvas.addEventListener('webglcontextrestored', function () {
      if (!initGL()) { return; }                // ricrea shader/program/buffer/uniform
      resize();                                 // ripristina viewport + iResolution
      if (!document.hidden) play();             // riavvia il clock se la tab è visibile
      if (rafId == null) rafId = requestAnimationFrame(frame);
    }, false);

    /* --- init iniziale --- */
    if (!initGL()) { fail(); return; }
    resize();
    rafId = requestAnimationFrame(frame);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
